import { useSession } from 'contexts/session-context'
import useWhiteBg from 'hooks/use-white-bg'
import { createContext, useEffect, useState } from 'react'
import { Main } from 'theme/theme'
import ProfileService from 'services/profile-services'
import DynamicPopup from 'components/popUps/DynamicPopup'
import usePopupManager from 'hooks/use-popup-maganer'
export interface MainContextProps {
  classMain: string[]
  setClassMain: React.Dispatch<React.SetStateAction<string[]>>
  openPopup: (content: any) => void
  closePopup: () => void
}

const MainContext = createContext<MainContextProps>({} as MainContextProps)

const MainProvider = ({ children }) => {
  const [classMain, setClassMain] = useState<string[]>([])
  const { openPopup, popupContent, closePopup } = usePopupManager()
  const [intervalId, setIntervalId] = useState<any>()
  const { shouldUseWhiteBg, useTexture } = useWhiteBg()
  const [{ data: session }, { setTotalPoints }] = useSession();


  useEffect(() => {

    const getTotalPoints = async () => {
      // eslint-disable-next-line no-undef
      const response = await ProfileService.getMovements({ session });
      setTotalPoints(response?.data?.totalPoints)
    }

    clearInterval(intervalId);

    // Create an interval that increments the count every 1000ms (1 second)
    const interval = setInterval(() => {
      if (session) {
        getTotalPoints();
      }
    }, INTERVAL_MOVEMENTS ? Number(INTERVAL_MOVEMENTS) : 60000);

    setIntervalId(interval);

    // Clean up the interval when the component unmounts
    return () => clearInterval(intervalId);

  }, [session])


  const data = { classMain, setClassMain, openPopup, closePopup }

  return (
    <MainContext.Provider value={data}>
      <Main
        shouldUseWhiteBg={shouldUseWhiteBg}
        useTexture={useTexture}
        className={`min-h-view select-none flex flex-col items-center relative z-1 ${classMain.join(" ")}`}
      >
        <DynamicPopup isOpen={!!popupContent} onClose={popupContent?.onClose ? popupContent?.onClose : closePopup}>
          {popupContent?.content ? popupContent?.content : popupContent}
        </DynamicPopup>
        {children}
      </Main>
    </MainContext.Provider>
  )
}

export { MainProvider, MainContext }